import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderNameFragment = { __typename?: 'FolderAsset', id: string, name: string, restricted?: boolean | null, userProvidedColor?: string | null, project?: { __typename?: 'Project', id: string } | null };

export const FolderName = /*#__PURE__*/ gql`
    fragment FolderName on FolderAsset {
  id
  name
  restricted
  userProvidedColor
  project {
    id
  }
}
    ` as unknown as DocumentNode<FolderNameFragment, unknown>;

        

        
export const useFolderNameFragment = (
  input: string | Omit<UseFragmentOptions<FolderNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderNameFragment>({
    fragment: FolderName,
    fragmentName: 'FolderName',
    ...options,
  });
};
  
        